import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class DropdownItem extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    text: PropTypes.string,
    children: PropTypes.node,
    isSelected: PropTypes.bool
  };

  render() {
    const { className, text, children, isSelected, ...props } = this.props;
    const classComponent = classNames('dropdown__menu__item', className, {
      dropdown__menu__selected: isSelected
    });

    return (
      <a className={classComponent} {...props}>
        {text ? <I18n label={text} /> : children}
      </a>
    );
  }
}
